// @ts-check
import React from 'react';

import GlobeIcon from '@liquidweb-dev/undercurrent/icons/lucide/Globe';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/**
 * @param {import('@liquidweb-dev/undercurrent/Stack').StackProps & {
 *   serverDescription?: string;
 *   domain?: string | null;
 * }} props
 */
const HostingDetailsDescription = ({
	serverDescription,
	domain,
	sx,
	...rest
}) => {
	return (
		<Stack
			sx={combineSx(
				{
					gap: 100,
				},
				sx,
			)}
			{...rest}
		>
			{serverDescription && (
				<Typography variant="body-md">{serverDescription}</Typography>
			)}
			{domain && (
				<Stack direction="row" gap={50} alignItems="center">
					<GlobeIcon />
					<Typography
						variant="label-lg"
						sx={{
							color: ({ palette }) => palette.uc.text.weak,
							fontWeight: 500,
						}}
					>
						{domain}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};

export default HostingDetailsDescription;
